import React from "react";

const FullModal = ({ children }) => {
  return (
    <div className="fixed backdrop-blur-md top-0 bottom-0 left-0 right-0 bg-black/60 z-[5] flex justify-center items-center">
      {children}
    </div>
  );
};

export default FullModal;
